<template>
  <span class="r-icon">
    <img
      :src="src"
      alt="triangle with all three sides equal"
      height="87"
      width="100"
    />
  </span>
</template>

<script>
export default {
  props: {
    src: String,
  },
  data() {
    return {};
  },
  methods: {},
  mounted() {},
};
</script>

<style lang="scss"></style>
